<div [id]="field.attributes.id" (blur)="touch()">
  <table class="packages custom">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th class="text-center">Included in this package</th>
        <th class="text-center">Time variant</th>
        <th aria-hidden="true">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for (workflow of workflows; track workflow) {
      <tr>
        <th class="splitter" colspan="4">{{ workflow.label }}</th>
      </tr>
      <tr aria-hidden="true" class="spacer">
        <td aria-hidden="true">&nbsp;</td>
        <td aria-hidden="true">&nbsp;</td>
        <td aria-hidden="true">&nbsp;</td>
        <td aria-hidden="true">&nbsp;</td>
      </tr>
      @for (service of workflow.services; track service; let odd = $odd) {
      <tr [class.even]="odd">
        <th scope="row">{{ service.name }}</th>
        <td class="text-center">
          <select
            [(ngModel)]="value[service.id].package_status"
            (change)="propagateValueChange()"
            [disabled]="disabled"
            class="form-select"
          >
            <option value="DISABLED">Disabled</option>
            <option value="CORE">Core</option>
            <option value="FLEXIBLE">Flexible</option>
          </select>
        </td>
        @if (!service.variations) {
        <td class="text-center not-available">
          <empty>n/a</empty>
        </td>
        } @if (service.variations) {
        <td class="text-center not-available">
          <select
            [(ngModel)]="value[service.id].variation"
            (change)="propagateValueChange()"
            [disabled]="
              value[service.id].package_status === 'DISABLED' || disabled
            "
            class="form-select"
          >
            @for (variation of service.variations | values; track variation) {
            <option [value]="variation.id">
              {{ variation.value }} {{ variation.label }}
            </option>
            }
          </select>
        </td>
        }
        <td aria-hidden="true">&nbsp;</td>
      </tr>
      } }
    </tbody>
  </table>
</div>
